import React from 'react';
import { Typography } from '@mui/material';
import DataSourceIcon from 'js/components/data_sources/DataSourceIcon';
import ConfigFieldValue from 'js/components/data_sources/cards/configViews/ConfigFieldValue';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CREDENTIALS } from 'new/constants/pathnames';
import { Stack } from 'new/elements/Stack';
import { Column } from 'new/elements/Table/types';
import { Link } from 'react-router-dom';

export const quarantineColumns = [
  {
    name: 'Credential',
    field: 'credential.name',
    renderRow(row) {
      return (
        <Stack direction="row" gap="8px" alignItems="center">
          <DataSourceIcon icon={row.sourceIcon} />
          <Link to={`${ROUTE_REDESIGN}${ROUTE_CREDENTIALS}/${row.credential?.id}`}>
            <Typography>{row?.credential?.name || row.sourceName}</Typography>
          </Link>
        </Stack>
      );
    },
  },
  {
    name: 'Write frequency',
    field: 'cronField',
    renderRow(row) {
      return <ConfigFieldValue field={row.cronField} value={row.config['start.cron']} />;
    },
  },
  {
    name: 'Location',
    field: 'sourceLocation',
  },
] as Column<any>[];
